import { Processo } from './processo.model';
import { Esteira } from './esteira.model';
import { Pessoa } from './pessoa.model';
import { Plano } from './plano.model';
import { Parentesco } from './parentesco.model';

export class WebTempDependente {
    idPessoaDep: number;
    nomeDependente: string;
    idParentesco: number;
    nrCpfDependente:number;
    idFinalidade: number;
    participacao: number;
    icInvalido: string;
    dtIni: Date;
    dtFim: Date;
    dtNascimentoDep: Date;
    icintegrado: string;
    nrProtocolo: string;
    pcParticipacao: number;
    pessoa: Pessoa;
    webTipoProcesso: Processo;
    webEsteiraStatus: Esteira;
    plano: Plano;
    parentesco: Parentesco;
    icSexo: string;
    icSuperior: string;
    idTemp: number;
}